import { z } from 'zod';

const beforeAndAfterValueSchema = z.object({
    oldVal: z.string(),
    newVal: z.string(),
});

const reportValueChangeSchema = z.object({
    label: beforeAndAfterValueSchema.nullish(),
    coreValue: beforeAndAfterValueSchema.extend({ kind: z.string().nullish() }).nullish(),
});

export type ReportValueChangeType = z.infer<typeof reportValueChangeSchema>;

export const financialReportChangesSchema = z.object({
    statistic: z.object({
        addedReports: z.number(),
        removedReports: z.number(),
        addedCoreValues: z.number(),
        changedCoreValues: z.number(),
        removedCoreValues: z.number(),
        addedLabels: z.number(),
        changedLabels: z.number(),
        removedLabels: z.number(),
        dataAddedBecauseOfNewDescriptor: z.number(),
        dataRemovedBecauseOfRemovedDescriptor: z.number(),
    }),
    changes: z.object({
        schemaDiff: z.object({
            addedDescriptors: z.record(z.string()),
            removedDescriptors: z.record(z.string()),
        }),
        reportsDiff: z.object({
            descriptors: z.record(z.string()),
            addedReports: z.array(z.string()),
            removedReports: z.array(z.string()),
            reports: z.array(z.object({
                year: z.number(),
                period: z.string(),
                diffs: z.record(reportValueChangeSchema),
            })),
        }),
    }),
});

export type FinancialReportChangesType = z.infer<typeof financialReportChangesSchema>;
